import { render, staticRenderFns } from "./YMmpProductItem.vue?vue&type=template&id=e43e5dfe&scoped=true&"
import script from "./YMmpProductItem.vue?vue&type=script&lang=js&"
export * from "./YMmpProductItem.vue?vue&type=script&lang=js&"
import style0 from "./YMmpProductItem.vue?vue&type=style&index=0&id=e43e5dfe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e43e5dfe",
  null
  
)

export default component.exports